import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ClothingStore",
  components: {},
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('<<<<<<<<< ClothingStore mounted >>>>>>>>>');
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      currentPage: 1,
      itemsPerPage: 9,
      selectedItem: null
    };
  },
  methods: {
    selectItem: function selectItem(item) {
      this.selectedItem = item;
    },
    closeModal: function closeModal() {
      this.selectedItem = null;
    },
    nextPage: function nextPage() {
      if (this.currentPage * this.itemsPerPage < this.storeItems.length) {
        this.currentPage++;
      }
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
});